import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import {Box, Flex, Img, Text, useBreakpointValue, useMultiStyleConfig} from '@chakra-ui/react'
import CurrentPrice from '../../../display-price/current-price'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getPriceData} from '../../../../utils/product-utils'
import OmnibusPrice from '../../../display-price/omnibus-price'
import {getGlobalLink} from '../../../../utils/contentstack-utils'
import {useProducts} from '@salesforce/commerce-sdk-react'

const ProductBox = ({product, styleVariant}) => {
    const styles = useMultiStyleConfig('ProductMoodboard', {variant: styleVariant})

    const viewType = useBreakpointValue({base: 'small', lg: 'medium'})

    const {locale} = useMultiSite()

    const images = product?.imageGroups?.find((group) => group.viewType == viewType)?.images
    const image = images && images?.length > 0 ? images[0] : {}

    const priceData = getPriceData(product || {})
    const {data: productsData} = useProducts({
        parameters: {
            ids: product?.id || '',
            allImages: false,
        },
    })
    const {url, label} = getGlobalLink({
        link: {productsfcc: {data: [{id: product?.id || ''}]}},
        productsData,
        locale: locale?.alias || locale?.id?.toLowerCase(),
    })

    return (
        <Flex
            data-testid="product-box"
            as={Link}
            to={url ?? '#'}
            title={label}
            {...styles.productbox}
        >
            <Box {...styles.imagecontainer} className={'img-container'}>
                <Img src={image?.link || ''} alt={image?.alt || ''} {...styles.image} />
                <Box {...styles.imageoverlay} />
            </Box>
            <Flex {...styles.textbox}>
                <Text {...styles.productId}>{product?.id || <>&nbsp;</>}</Text>
                <Text {...styles.productName}>
                    {product?.c_variantIdentifier || product?.name || product?.productName || (
                        <>&nbsp;</>
                    )}
                </Text>
                {product?.price && product?.currency ? (
                    <CurrentPrice
                        price={product?.price}
                        currency={product?.currency}
                        {...styles.price}
                    />
                ) : (
                    <Text {...styles.price}>&nbsp;</Text>
                )}
                <Flex {...styles.omnibusPrice}>
                    {(priceData?.showOmnibusPrice || priceData?.showOmnibusPriceDiscount) &&
                    product?.currency ? (
                        <OmnibusPrice
                            priceData={priceData}
                            currency={product?.currency}
                            omnibusExpandedView={false}
                            showDiscount={true}
                            variant={'recommended'}
                        />
                    ) : (
                        <>&nbsp;</>
                    )}
                </Flex>
            </Flex>
        </Flex>
    )
}

ProductBox.propTypes = {
    product: PropTypes.shape(),
    styleVariant: PropTypes.string,
}

export default ProductBox
